/** Action responsável por tratar quando o valor de uma data é alterado */
function dataChange(object) {
  return {
    type: "DATA_CHANGE",
    datas: object
  };
}

export default dataChange;



// WEBPACK FOOTER //
// ./src/store/actions/acordo/data/change.js